import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
@Component({
    template: `<p>OK</p>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HealthCheckComponent implements OnInit{
  constructor() { }
  ngOnInit() {
    // Intentionally left blank for future initialization logic
  }
}